(function () {
  if (navigator.webdriver) return;
  var WORKER = 'https://gms.hudsongraeme.workers.dev';
  var queue = [];
  var timer = null;

  function rand() { return Math.random().toString(36).slice(2, 12) + Date.now().toString(36); }
  function store(kind, key) {
    try {
      var s = kind === 'session' ? sessionStorage : localStorage;
      var v = s.getItem(key);
      if (!v) { v = rand(); s.setItem(key, v); }
      return v;
    } catch (e) { return 'na'; }
  }
  var sid = store('session', 'gms_sid');
  var vid = store('local', 'gms_vid');
  var landing = null;
  try { landing = new URL(sessionStorage.getItem('gms_landing') || location.href, location.origin); } catch (e) {}
  var utm = {};
  try {
    var first = new URLSearchParams(landing ? landing.search : location.search);
    utm.source = first.get('utm_source') || '';
    utm.medium = first.get('utm_medium') || '';
  } catch (e) {}
  var referrerHost = '';
  try { referrerHost = sessionStorage.getItem('gms_referrer') && sessionStorage.getItem('gms_referrer') !== 'direct' ? new URL(sessionStorage.getItem('gms_referrer')).hostname : (document.referrer ? new URL(document.referrer).hostname : ''); } catch (e) {}
  if (referrerHost === location.hostname) referrerHost = '';

  function gmsCanonicalPath() {
    return location.pathname.replace(/^\/fr(?=\/|$)/, '') || '/';
  }

  function pageType() {
    var p = gmsCanonicalPath();
    if (p === '/') return 'home';
    if (p.indexOf('/pages/bandsaw-blades/') === 0) return 'machine';
    if (p.indexOf('/products/') === 0) return 'product';
    if (p.indexOf('/collections/') === 0) return 'collection';
    if (p === '/cart') return 'cart';
    if (p.indexOf('/pages/distributors') === 0) return 'portal';
    if (p.indexOf('/pages/') === 0) return 'page';
    if (p.indexOf('/search') === 0) return 'search';
    if (p.indexOf('/blogs/') === 0) return 'article';
    return 'other';
  }

  function flush() {
    timer = null;
    if (!queue.length) return;
    var batch = queue.splice(0, 25);
    var body = JSON.stringify({ events: batch });
    var sent = false;
    try { sent = navigator.sendBeacon(WORKER + '/events', new Blob([body], { type: 'text/plain' })); } catch (e) {}
    if (!sent) {
      fetch(WORKER + '/events', { method: 'POST', body: body, headers: { 'Content-Type': 'text/plain' }, keepalive: true }).catch(function () {});
    }
    if (queue.length) flush();
  }

  function track(name, props) {
    props = props || {};
    queue.push({
      e: String(name).slice(0, 40),
      t: Date.now(),
      sid: sid,
      vid: vid,
      path: gmsCanonicalPath().slice(0, 200),
      type: pageType(),
      ref: referrerHost.slice(0, 100),
      us: utm.source.slice(0, 60),
      um: utm.medium.slice(0, 60),
      w: window.innerWidth,
      line: props.line ? String(props.line).slice(0, 40) : '',
      width: props.width ? String(props.width).slice(0, 20) : '',
      tpi: props.tpi ? String(props.tpi).slice(0, 20) : '',
      unit: props.unit ? String(props.unit).slice(0, 10) : '',
      length: Number(props.length) || 0,
      price: Number(props.price) || 0,
      qty: Number(props.qty) || 0,
      machine: props.machine ? String(props.machine).slice(0, 80) : (pageType() === 'machine' ? location.pathname.split('/').pop().slice(0, 80) : ''),
      x: props.x ? String(props.x).slice(0, 200) : ''
    });
    if (!timer) timer = setTimeout(flush, 800);
  }
  window.gmsTrack = track;

  track('page_view', { x: document.title.slice(0, 120) });

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a, button');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.indexOf('tel:') === 0) track('phone_click', { x: href });
    else if (href.indexOf('mailto:') === 0) track('email_click', { x: href });
    else if (a.getAttribute('name') === 'checkout' || href.indexOf('/checkout') === 0) track('checkout_click');
    else if (a.hasAttribute('data-portal-link')) track('portal_link_click');
    else if (a.classList.contains('gms-add-btn') || a.id === 'add-to-cart-custom' || a.id === 'mb-add-to-cart') track('add_to_cart_click', { x: a.id || 'form' });
    else if (a.closest('#mbw-pills, #mbw-alts, #mbw-tpi')) track('machine_pick', { x: (a.textContent || '').trim().slice(0, 60) });
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    var action = f.getAttribute('action') || '';
    if (f.id === 'ContactForm' || action.indexOf('/contact') === 0) track('contact_submit');
    else if (action.indexOf('/cart/add') === 0) track('add_to_cart_submit');
    else if (action.indexOf('/search') === 0) track('search', { x: (f.querySelector('input[name="q"]') || {}).value || '' });
  }, true);

  var searchInput = document.getElementById('teslaSearchInput');
  if (searchInput) {
    searchInput.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' && searchInput.value.trim()) track('search', { x: searchInput.value.trim() }); });
  }

  var depthMarks = { 50: false, 90: false };
  window.addEventListener('scroll', function () {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h <= 0) return;
    var pct = Math.round(window.scrollY / h * 100);
    [50, 90].forEach(function (m) { if (!depthMarks[m] && pct >= m) { depthMarks[m] = true; track('scroll_' + m); } });
  }, { passive: true });

  var started = Date.now();
  window.addEventListener('pagehide', function () {
    track('page_leave', { length: Math.round((Date.now() - started) / 1000) });
    flush();
  });
})();
